import React from "react";
import IconSvg from "./IconSvg";
import "./style.css";

const RoleAnalysisModal = ({ isOpen, onClose, roles }) => {
  if (!isOpen) return null;
  const handleOutsideClick = (e) => {
    if (e.target.className === "modal-overlay") {
      onClose();
    }
  };

  console.log("roles", roles);
  return (
    <div className="modal-overlay" onClick={handleOutsideClick}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="modal-content">
        <div className="modal-header ">
          <div className="flex justify-between items-center w-full">
            <h3 className="modal-header-title">All Role Fits</h3>
            <button onClick={onClose} className="modal-close-button">
              <IconSvg path="M6 18L18 6M6 6l12 12" className="h-6 w-6" />
            </button>
          </div>
        </div>
        <div className="modal-body">
          <div className="modal-note">
            <span>
              <span className="font-medium">Note:</span> Numbers in each column
              represent the <strong>count of students</strong> matched with each
              role at different readiness levels.
            </span>
          </div>
          <div className="modal-table-container">
            <table className="modal-table">
              <thead className="modal-table thead">
                <tr>
                  <th scope="col">Role Name</th>
                  <th scope="col">
                    <div className="flex items-center">
                      <span>Strong Fits</span>
                      <div className="tooltip-wrapper">
                        <IconSvg
                          path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          className="tooltip-icon"
                        />
                        <div className="tooltip-content w-44">
                          Students that match 90% or more with role requirements
                        </div>
                      </div>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="flex items-center">
                      <span>Capable Fits</span>
                      <div className="tooltip-wrapper">
                        <IconSvg
                          path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          className="tooltip-icon"
                        />
                        <div className="tooltip-content w-44">
                          Students that match 70-89% with role requirements
                        </div>
                      </div>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="flex items-center">
                      <span>Emerging Fits</span>
                      <div className="tooltip-wrapper">
                        <IconSvg
                          path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          className="tooltip-icon"
                        />
                        <div className="tooltip-content w-44">
                          Students that match 50-69% with role requirements
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="modal-table tbody">
                {roles.map((role) => (
                  <tr key={role.role}>
                    <td>{role.role}</td>
                    <td>
                      <span className="score-badge green">
                        {role.advanced_count} students
                      </span>
                    </td>
                    <td>
                      <span className="score-badge yellow">
                        {role.intermediate_count} students
                      </span>
                    </td>
                    <td>
                      <span className="score-badge blue">
                        {role.beginner_count} students
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="modal-footer-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleAnalysisModal;
